import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-feather-message-square",
  "use": "icon-feather-message-square-usage",
  "viewBox": "0 0 97 97",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 97 97\" id=\"icon-feather-message-square\"><defs><style>#icon-feather-message-square .a{fill:none;stroke:#1db78b;stroke-linecap:round;stroke-linejoin:round;stroke-width:12px;}</style></defs><path class=\"a\" d=\"M89.5,61.167a9.444,9.444,0,0,1-9.444,9.444H23.389L4.5,89.5V13.944A9.444,9.444,0,0,1,13.944,4.5H80.056A9.444,9.444,0,0,1,89.5,13.944Z\" transform=\"translate(1.5 1.5)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol